import styled from 'styled-components';
import { themeGet } from 'styled-system';

export const StyledHeader = styled.header`
  position: sticky;
  top: 0;
  z-index: 1001;
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${themeGet('heights.appHeader')}px;
  background-color: ${themeGet('colors.header.bg')};
  border-bottom: ${themeGet('borders.header')};
  color: ${themeGet('colors.header.text')};

  &.legacy {
    position: fixed;
    z-index: 200;
    padding: 0 10px;
    width: 100%;
  }
`;

export const StyledMobileMenu = styled.div<{ isOpen: boolean }>`
  overflow-y: scroll;
  position: fixed;
  top: ${themeGet('sizes.appHeader')}px;
  left: ${props => (props.isOpen ? 0 : '-100vw')};
  width: 280px;
  min-height: ${themeGet('minHeights.contentWithHeader')};
  background-color: ${themeGet('colors.whiteSmoke')};
  color: ${themeGet('colors.textSecondary')};
  transition: left 0.3s;
  will-change: left;
`;

export const StyledBlackout = styled.div<{ isOpen: boolean }>`
  z-index: 0;
  position: absolute;
  top: ${themeGet('sizes.appHeader')}px;
  left: 0;
  height: 100vh;
  width: ${props => (props.isOpen ? '100vw' : '0px')};
  opacity: ${props => (props.isOpen ? 0.9 : 0)};
  transition: opacity 0.8s;
  background-color: #5b636d;
`;
